import React from "react";
import useConditionalTranslation from "../utils/hooks/useConditionalTranslation";
import Sizes from "./Sizes";

interface TextProps {
  size?: Sizes;
  children?: string | string[] | React.ReactNode;
  className?: string;
  onClick?: any;
  translate?: boolean;
  dataTestId?: string;
  // TODO: move in index css
  bold?: boolean;
  uppercase?: boolean;
  styles?: React.CSSProperties;
}

const Text = ({
  size,
  translate = true,
  uppercase = false,
  children,
  className,
  bold = false,
  dataTestId,
  onClick,
  styles: _styles,
}: TextProps) => {
  // useConditionalTranslation must be called unconditionally (rules-of-hooks).
  // It only translates strings ending in ".translation" and returns any other
  // value unchanged, so calling it always is behaviour-preserving; the guard
  // below only decides whether the translated result is used.
  const translatedChildren = useConditionalTranslation(children);
  const label =
    translate &&
    typeof children === "string" &&
    children.endsWith(".translation")
      ? translatedChildren
      : children;
  // Extendible props
  const props = {
    className,
    onClick,
  };

  const getStyle = () => {
    let styles = _styles || {};
    if (size) {
      styles = { ...styles, fontSize: `${size}rem` };
    }
    if (uppercase) {
      styles = { ...styles, textTransform: "uppercase" };
    }
    return styles;
  };

  if (bold) {
    return (
      <strong data-testid={dataTestId} style={getStyle()} {...props}>
        {label}
      </strong>
    );
  }

  return (
    <span data-testid={dataTestId} style={getStyle()} {...props}>
      {label}
    </span>
  );
};

export default React.memo(Text);
